import { hasErrorBoundary } from '@xmanscript/has-error-boundary';
import { cn } from '@/utils';
import Checkbox from './CheckBox';
import Input from './Input';
import Upload from './Upload';
import CheckBoxGroup from './CheckBoxGroup';
import ChipSelector from './ChipSelector';
import IconSelector from '../IconSelector';
import InputLabel from './_lib/InputLabel';
import ErrorLabel from './_lib/ErrorLabel';
import RadioButton from './RadioButton';
import { Switch } from '../Switch'; // Add Switch component

interface FormControlProps {
  controlType: string;
  label?: string;
  error?: string;
  tooltipMessage?: string;
  className?: string;
  disabled?: boolean;
  requiredControl?: boolean;
  touched?: boolean;
  touchederror?: string;
  // Add specific props that should not be passed to DOM elements
  haserror?: boolean;
  onTouchHandler?: any;
  enable?: boolean;
  controlfilling?: boolean;
  // Form registration props
  name?: string;
  onChange?: (value: any) => void;
  onBlur?: () => void;
  value?: any;
  ref?: React.Ref<any>;
  [key: string]: any;
}

const FormControl: React.FC<FormControlProps> = ({
  controlType,
  label = '',
  error,
  tooltipMessage,
  className,
  disabled,
  requiredControl = false,
  touched,
  touchederror,
  haserror,
  onTouchHandler,
  enable,
  controlfilling,
  name,
  onChange,
  onBlur,
  value,
  ref,
  ...props
}) => {
  const controlElements: { [key: string]: React.ElementType } = {
    input: Input,
    checkBox: Checkbox,
    upload: Upload,
    radio: RadioButton,
    checkboxGroup: CheckBoxGroup,
    chipSelector: ChipSelector,
    iconSelector: IconSelector,
    switch: Switch,
  };

  const ControlElement = controlElements[controlType];

  // Check if ControlElement is valid
  if (!ControlElement) {

    return null;
  }

  // Pass form registration props to the control element
  const controlProps = {
    ...props,
    name,
    onChange,
    onBlur,
    value,
    ref,
    error,
    disabled,
  };

  return (
    <div className={cn('form-control flex w-full flex-col gap-[0.5rem]', className)}>
      {label && (
        <InputLabel label={label} tooltipMessage={tooltipMessage} astric={requiredControl} disabled={disabled} />
      )}
      <ControlElement {...controlProps} />
      {touchederror && <ErrorLabel message={touchederror} disabled={disabled} />}
    </div>
  );
};

export default hasErrorBoundary(FormControl);